import React, { useEffect, useState, useContext } from 'react';

import { useAuth } from '../../contexts/auth2';
import { Navigate,NavLink, useNavigate } from 'react-router-dom';
import { Instagram, Facebook, ChevronRight } from 'lucide-react';


const Success = () => {
    const { signup, signed } = useAuth();
    const [email, setEmail] = useState();
    const [cnpjcpf,setCnpjcpf] = useState();
    const [name, setName] = useState();
    const [password1, setPassword1] = useState();
    const [password2, setPassword2] = useState();
    const [loading, setLoading] = useState(false); // controle do botão
    

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
  e.preventDefault();
  setLoading(true);

  const payload = { name, email, cnpjcpf, password1, password2 };

  try {
    const response = await signup(payload);

    if (response.status === 1) {
      //alert(response.message);
      navigate('/login'); // força login
    } else {
      alert(response.message || 'Erro ao cadastrar');
      // permanece no cadastro
      return
    }
  } catch (err) {
    alert(JSON.stringify(err));
    console.log('Erro ao cadastrar', JSON.stringify(err));
  } finally {
    setLoading(false);
  }
};
     
    
    if(!signed){
        return (
          <div>
            <div className='bg-success'>
              <div className="bx-input"><img style={{width: '120px'}} className='logo-login' src='../files/img/logo-1.svg'/></div>
              <div className='bg-success-body' style={{background: '#43ACC2'}}><img style={{width: 'auto'}} className='logo-login' src='../files/img/signup-bg.png'/></div>
            </div>
            <div className='box-login-nr' style={{textAlign: 'center', color: '#181D27'}}>

                        
                    
                        
                        <div className="bx-input"><h1>Seu cadastro foi concluído com sucesso!</h1></div>
                        <div className="bx-input" style={{width: '50%',marginLeft: 'auto',marginRight: 'auto',lineHeight: '23px'}}><span>Agora você está pronto para gerenciar suas prescrições e fornecer o melhor atendimento aos seus pacientes. Aproveite todos os recursos da nossa plataforma para otimizar o processo de administração e entrega de medicamentos.</span></div>
                        
                      


                        

                        <div className="bx-input">
                            
                            <NavLink to="/login">
                                <button
                                className="btn btn-1"
                                style={{marginLeft: 'auto',marginRight: 'auto',marginTop: '20px', width: 'auto', padding: '15px 25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                disabled={loading}
                                >
                                
                                <div style={{ margin: '0px 0px 0px 10px' }}>
                                    {loading ? 'Carregando...' : 'PROSSEGUIR PARA O LOGIN'}
                                </div>
                                <ChevronRight size={20} />
                                </button>
                            </NavLink>
                        </div>
             
           
                        <div className="bx-input" style={{margin: '100px 0px 0px 0px'}}><span>Siga a TopFarm nas redes sociais</span></div>
                        <div style={{display: 'flex', justifyContent: 'center', marginTop: '10px'}}>

                            <NavLink to="https://facebook.com" style={{marginRight: '5px'}}><img src="../files/img/facebook.png" width='25'/></NavLink>
                          
                            <NavLink to="https://instagram.com"><img src="../files/img/instagram.png" width='25'/></NavLink>
                          
                        </div>
            
        </div>
        </div>
        );
    }else{
        return <Navigate to="/dashboard" />;
    }
}
export default Success;